import { render, staticRenderFns } from "./dashboard-info-user-info.vue?vue&type=template&id=67f41ba8&scoped=true"
import script from "./dashboard-info-user-info.vue?vue&type=script&lang=js"
export * from "./dashboard-info-user-info.vue?vue&type=script&lang=js"
import style0 from "./dashboard-info-user-info.vue?vue&type=style&index=0&id=67f41ba8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f41ba8",
  null
  
)

export default component.exports